import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import LiveClassesDefault from './Default';
import LiveClassesPlayful from './Playful';
import ViewLiveClass from './ViewLiveClass';

function LiveClasses(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return isPlayfulStudentTheme ? <LiveClassesPlayful {...props} /> : <LiveClassesDefault {...props} />;
}

export { LiveClasses, ViewLiveClass };
